import { render, staticRenderFns } from "./UserInvitationList.vue?vue&type=template&id=c1a8bdc8&scoped=true&"
import script from "./UserInvitationList.vue?vue&type=script&lang=js&"
export * from "./UserInvitationList.vue?vue&type=script&lang=js&"
import style0 from "./UserInvitationList.vue?vue&type=style&index=0&id=c1a8bdc8&lang=scss&scoped=true&"
import style1 from "./UserInvitationList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a8bdc8",
  null
  
)

export default component.exports